export default __webpack_public_path__ + "static/media/take-away.6c9d042f.svg";